import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import {
  Hero,
  OurMethod,
  WhatWeDo,
  TheyTrustUs,
} from "../components/OurExpertise";
import Container from "../components/Common/Container";
import Testimonials from "../components/Home/Testimonials";

import MetaTags from "../components/Common/MetaTags/MetaTags.js";

export default function OurExpertise() {
  const theme = useTheme();

  return (
    <>
      <MetaTags scope="our-expertise" />

      <Box>
        <Container>
          <Hero />
        </Container>

        <Box
          bgcolor={theme.palette.alternate.main}
          paddingTop={5}
          paddingBottom={7}
        >
          <Container>
            <WhatWeDo />
          </Container>
        </Box>
        <Container marginTop={5} marginBottom={7}>
          <OurMethod />
        </Container>
        <Box bgcolor={theme.palette.alternate.main}>
          <Container>
            <TheyTrustUs />
          </Container>
        </Box>
        <Container paddingX={"0 !important"} maxWidth={"100%"}>
          <Testimonials />
        </Container>
      </Box>
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "common",
        "our-expertise",
        "testimonials",
      ])),
    },
  };
}
